export default "__VITE_ASSET__C3LtoqVx__"